<template>
    <div>
        <div v-if="!isNavigator" style='text-align:center;color:#333;margin-top:160px;line-height:26px'>暂时不支持其它浏览器访问，请使用<br/>APP打开此页面</div>
        <div class="hongbao_bg" v-if="isNavigator">
            <!--红包文字-->
            <div class="hongbao_tit">
                <img :src="cpnImgUrl" alt="">
            </div>
            <!--红包-->
            <div class="hongbao_foot">
                <div class="hongbao_img">
                    <!--拆开前的内容-->
                    <img src="../../assets/img/hb_img01.png" alt="" v-show="isShow">
                    <template v-if="loading">
                        <div class="hongbao_but" v-show="isShow" @click="doShow">
                            <img src="../../assets/img/hb_chai.png" alt="">
                        </div>
                    </template>
                    <template v-else>    
                        <div class="hongbao_but" v-show="isShow">
                            <img src="../../assets/img/hb_chai.png" alt="">
                        </div>
                    </template>
                    <!--拆开后的内容-->
                    <img src="../../assets/img/hb_img03.png" alt="" v-show="!isShow">
                    <div class="hongbao_money" v-show="!isShow">
                        <h1>{{cpnAmt}}元</h1>
                        <span>恭喜您获得</span>
                    </div>
                    <div class="img_jinbi"><img src="../../assets/img/hb_img04.png" alt=""></div>
                </div>
                <img src="../../assets/img/hb_bottom.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isNavigator:true,//判断是否为APP内置浏览器
                isShow:true,//控制红包拆开按钮
                appTag:1,//app品牌 0 佳付通 1 富裕钱包 2我是队长
                cpnUid:'',//红包编号
                officeCode:'',
                token:'',
                cpnAmt:'',//红包面值
                cpnImgUrl:'',
                loading : true
            }
        },
        created () {
            document.title = "领取红包"
            var ua = navigator.userAgent;
            // if (ua.match(/redenvelopes/i) == 'redenvelopes') {
            //     console.log(111)
            // } else {
            //     this.isNavigator = false
            //     return false;
            // }
            let appTag = this.$route.query.appTag;
            if(!!appTag){
                this.appTag = appTag;
            }
            let cpnUid = this.$route.query.cpnUid;
            if(!!cpnUid){
                this.cpnUid = cpnUid;
            }
            let officeCode = this.$route.query.officeCode;
            if(!!officeCode){
                this.officeCode = officeCode;
            }
            let token = this.$route.query.token;
            if(!!token){
                this.token = token;
            }
            this.getCpnOfficeInfo();//查询红包信息
        },
        methods: {
            doShow() {
                this.loading = false;
                this.openCpn();//拆红包
            },
            //查询红包信息
            getCpnOfficeInfo(){
                var params = {};
                params["appTag"] = this.appTag;
                params["cpnUid"] = this.cpnUid;
                params["officeCode"] = this.officeCode;
                params["token"] = this.token;
                this.$baseUrl("active/v1/getCpnOfficeInfo", params).then((res) => {
                    let data = res.data;
                    if (data.code == "0000") {
                        if(data.cpnImgUrl!=''){
                            this.cpnImgUrl = data.cpnImgUrl;
                        }
                        let isOpened = data.cpnInfo.isOpened;//是否已经打开
                        if(isOpened == 0){//未打开
                            this.isShow = true;
                        }else{//已经打开的
                            this.isShow = false;
                            this.cpnAmt = data.cpnInfo.cpnAmt;//红包面值
                        }
                    } else {
                        this.$toast(data.msg);
                    }
                });
            },
            openCpn(){
                var params = {};
                params["appTag"] = this.appTag;
                params["cpnUid"] = this.cpnUid;
                params["officeCode"] = this.officeCode;
                params["token"] = this.token;
                this.$baseUrl("active/v1/openCpn", params).then((res) => {
                    let data = res.data;
                    if (data.code == "0000") {
                        this.isShow = false;
                        this.cpnAmt = data.cpnInfo.cpnAmt;//红包面值
                    } else {
                        this.$toast(data.msg);
                    }
                    this.loading = true;
                });
            }
        },
    }
</script>

<style lang="scss" scoped>
img{
    width: 100%;
    display: inline-block;
}
.hongbao_bg{
    position: absolute;
    left: 0;
    width: 100%;
    top: 0;
    height: 100%;
    background: url(../../assets/img/hb_bg2.png) no-repeat center;
    background-size: 100% 100%;
}
.hongbao_tit{
    margin: 64px 23px 0;
}
.hongbao_img{
    margin: 0 10%;
    position: absolute;
    top: -320px;
}
.hongbao_but{
    width: 46%;
    position: absolute;
    left: 25.6%;
    bottom: 100px;
    animation:mymove 1s infinite;
    animation-direction:alternate;/*轮流反向播放动画。*/
    animation-timing-function: ease-in-out; /*动画的速度曲线*/
}
@keyframes mymove
{
    0%{
        transform: scale(1);
    }
    25%{
        transform: scale(1.2);
    }
    50%{
        transform: scale(1);
    }
    75%{
        transform: scale(1.2);
    }
}
.hongbao_bottom{
    position: absolute;
    width: 100%;
    bottom: 50px;
}
.hongbao_words{
    height: 20px;
    line-height: 20px;
    background-color: #c80a01;
    border-radius: 10px;
    text-align: center;
    color: #FDE6B5;
    font-size: 12px;
    margin: 0 42px;
}
.hongbao_money{
    color: #D52224;
    text-align: center;
    position: absolute;
    top: 60px;
    width: 100%;
}
.hongbao_money h1{
    font-size: 50px;
    line-height: 50px;
    margin-bottom: 20px;
    font-weight: normal;
    animation: changes 0.5s;
}
@keyframes changes{
    from {
        font-size: 96px;
        line-height: 96px;
        margin-bottom: 50px;
        opacity: 0;
    }
    to {
        font-size: 50px;
        line-height: 50px;
        margin-bottom: 20px;
        opacity: 1;
    }
}
.hongbao_money span{
    font-size: 30px;
    line-height: 30px;
}
.hongbao_foot{
    position: absolute;
    width: 100%;
    bottom: 25px;
}
.img_jinbi{
    width: 118px;
    position: absolute;
    right: -26px;
    bottom: -30px;
}
@media screen and ( min-height:780px ) {
  .hongbao_tit{
      margin-top:120px
  }
  .hongbao_img{
      top:-300px
  }
}
</style>